<template>
  <div class="logo-box d-flex gap-3 align-items-center">
    <img :src="logoclient" class="w-auto" alt="Logo client" />

    <div class="info-client">
      <h3>{{ clientDisplayName }}</h3>
      <span>Mon compte</span>
    </div>
  </div>

  <div class="dashboard-menu">
    <ul class="list-group">
      <li class="list-group-item">
        <a 
          href="#" 
          @click.prevent="changeTab('info_client')" 
          :class="{ active: activeTab === 'info_client' }"
          :aria-current="activeTab === 'info_client' ? 'page' : undefined"
        >
          Mes informations
        </a>
      </li>
      <li class="list-group-item">
        <a 
          href="#" 
          @click.prevent="changeTab('commandes_client')" 
          :class="{ active: activeTab === 'commandes_client' }"
          :aria-current="activeTab === 'commandes_client' ? 'page' : undefined"
        >
          Mes commandes
        </a>
      </li>
      <li class="list-group-item">
        <a 
          href="#" 
          @click.prevent="changeTab('adresses_client')" 
          :class="{ active: activeTab === 'adresses_client' }"
          :aria-current="activeTab === 'adresses_client' ? 'page' : undefined"
        >
          Mes adresses de livraison
        </a>
      </li>

      <li class="list-group-item">
        <a 
          href="#" 
          @click.prevent="changeTab('carnet_client')" 
          :class="{ active: activeTab === 'carnet_client' }"
          :aria-current="activeTab === 'carnet_client' ? 'page' : undefined"
        >
          Mon carnet de santé
        </a>
      </li>
    </ul>
  </div>

  <div class="logout-block">
    <button 
      @click.prevent="Logout" 
      class="btn-logout"
      type="button"
      aria-label="Se déconnecter"
    >
      <img :src="logout" alt="Déconnexion" />
      <span>Déconnexion</span>
    </button>
  </div>
</template>

<script>
  import logoclient from "@/assets/images/user-compte.png";
  import logout from "@/assets/images/logout.svg";
  import { useRegisterStore } from "@/stores/register";
  import { GENDERS } from "@/config/constants";

  export default {
    props: {
      activeTab: String,
    },
    emits: ["change-tab"],
    setup() {
      const registerStore = useRegisterStore();
      return { registerStore };
    },
    computed: {
      isOpen() {
        return this.manualOpen || ["calcul_ration", "rappel"].includes(this.activeTab);
      },
      clientDisplayName() {
        const clientInfo = this.registerStore.clientInfo;
        if (clientInfo && clientInfo.firstName && clientInfo.lastName) {
          const civilite = this.getCiviliteDisplay(clientInfo.gender);
          return `${civilite} ${clientInfo.lastName} ${clientInfo.firstName}`;
        }
        return "Client";
      },
    },
    name: "CompteUser",
    data() {
      return {
        logoclient,
        logout,
        manualOpen: false,
        openDropdown: null,
        dropdowns: {
          ration: false,
          documents: false,
        },
      };
    },
    async mounted() {
      // Charger les informations client si elles ne sont pas déjà disponibles
      if (!this.registerStore.clientInfo || Object.keys(this.registerStore.clientInfo).length === 0) {
        await this.registerStore.fetchClientInfo();
      }
    },
    methods: {
      changeTab(tab) {
        this.$emit("change-tab", tab);
      },
      handleSubmit() {
        this.form.search = "";
      },
      toggleDropdown(name) {
        this.dropdowns[name] = !this.dropdowns[name];
      },
      getCiviliteDisplay(genderCode) {
        const gender = GENDERS.find(g => g.code === genderCode);
        return gender ? gender.name : "";
      },
      Logout() {
        localStorage.removeItem("token");
        localStorage.clear();
        this.$router.push({ name: "Home" });
      },
    },
  };
</script>

<style scoped>
  .list-group-item a.active {
    color: #ffffff;
    font-weight: bold;
    background-color: #1e347d;
  }

  /* Améliorations responsives spécifiques */
  .btn-logout {
    background: none;
    border: none;
    color: var(--blue);
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0;
    font-size: inherit;
    transition: all 0.3s ease;
  }

  .btn-logout:hover {
    color: #0056b3;
    text-decoration: none;
  }

  .btn-logout:focus {
    outline: 2px solid var(--blue);
    outline-offset: 2px;
    border-radius: 4px;
  }

  .btn-logout img {
    width: 16px;
    height: 16px;
  }

  /* Amélioration de l'accessibilité */
  .list-group-item a {
    text-decoration: none;
    transition: all 0.3s ease;
  }


  /* Animation pour les transitions */
  .list-group-item {
    transition: transform 0.2s ease;
  }

  .list-group-item:hover {
    transform: translateX(2px);
  }

  /* Responsive pour très petits écrans */
  @media (max-width: 480px) {
    .logo-box {
      flex-direction: column;
      text-align: center;
      gap: 8px;
    }

    .info-client h3 {
      font-size: 14px;
    }

    .info-client span {
      font-size: 11px;
    }

    .btn-logout {
      font-size: 13px;
    }

    .btn-logout img {
      width: 14px;
      height: 14px;
    }
  }
</style>
